<script>
import { authComputed } from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isMenuOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saldo: 0,
    }
  },
  computed: {
    ...authComputed,
    isEmpresa169() {
      if (window.localStorage.getItem('modo_demo_169') === '1') return true

      const user = this.currentUser || {}
      const idCandidates = [
        user.id_empresa_sistema,
        user.id_empresa,
        user.idEmpresa,
        user.empresa_id,
        user.idEmpresaSistema,
        user.empresa && user.empresa.id_empresa_sistema,
        user.empresa && user.empresa.id_empresa,
        user.empresa && user.empresa.id,
      ]

      for (let i = 0; i < idCandidates.length; i += 1) {
        const parsed = Number(idCandidates[i])
        if (!Number.isNaN(parsed) && parsed > 0) {
          return parsed === 169
        }
      }

      return false
    },
  },
  mounted() {
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
    <div class="container-fluid">
      <!-- LOGO -->
      <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
        <span class="logo-lg">
          <img src="@assets/images/logo.png" alt height="32" />
          <span class="d-inline h5 ml-2 text-logo"></span>
        </span>
        <span class="logo-sm">
          <img src="@assets/images/logo.png" alt height="32" />
        </span>
      </a>


      <ul class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
        <li class>
          <button class="button-menu-mobile open-left disable-btn" :class="{ open: isMenuOpened }" @click="toggleMenu">
            <feather type="menu" class="menu-icon align-middle"></feather>
            <feather type="x" class="close-icon"></feather>
          </button>
        </li>
      </ul>
      <ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
        <li v-if="!isEmpresa169" class="d-none d-sm-block">
          <div class="app-search">
            <b-button href="/register/receita" class="custom-outline-btn">
              Emitir Receituário
            </b-button>
          </div>
        </li>

        <b-nav-item-dropdown id="bell-notification" right variant="white" class="notification-list"
          title="8 new unread notifications" menu-class="dropdown-lg">
          <!-- <template v-slot:button-content>
            <feather type="bell" class="align-middle"></feather>
            <span class="noti-icon-badge"></span>
          </template> -->
          <b-tooltip target="bell-notification" placement="left">8 new unread notifications</b-tooltip>
          <!-- item-->
          <b-dropdown-text class="noti-title border-bottom pb-2" tag="div">
            <h5 class="m-0 font-size-16">
              <span class="float-right">
                <a href class="text-dark">
                  <small></small>
                </a> </span>Notificações
            </h5>
          </b-dropdown-text>

          <VuePerfectScrollbar v-once class="noti-scroll">
            <!-- item-->
            <b-dropdown-text href="javascript:void(0);" class="notify-item border-bottom">
              Nenhuma notificação
            </b-dropdown-text>

          </VuePerfectScrollbar>
        </b-nav-item-dropdown>

        <!-- <li id="setting-tooltip" class="dropdown notification-list" title="Settings">
          <a href="javascript:void(0);" class="nav-link right-bar-toggle toggle-right" @click="toggleRightSidebar">
            <feather type="settings" class="toggle-right"></feather>
          </a>
          <b-tooltip target="setting-tooltip" placement="left">Settings</b-tooltip>
        </li> -->

        <b-nav-item-dropdown right class="notification-list align-self-center profile-dropdown"
          toggle-class="nav-user mr-0">
          <template v-slot:button-content>
            <div class="media user-profile">
              <div class="media-body text-left">
                <h6 class="pro-user-name ml-2 my-0">
                  <span>{{ user.user }}</span>
                  <span class="pro-user-desc text-white d-block mt-1">Administrator</span>
                </h6>
              </div>
              <feather type="chevron-down" class="ml-2 align-self-center"></feather>
            </div>
          </template>
          <b-dropdown-item v-if="!isEmpresa169" href="/configuracao/empresa" class="notify-item p-0">
            <feather type="user" class="icon-dual icon-xs mr-2"></feather>
            <span>Minha Conta</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="!isEmpresa169" href="/configuracao/config" class="notify-item p-0">
            <feather type="settings" class="icon-dual icon-xs mr-2"></feather>
            <span>Configurações</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="!isEmpresa169" href="/configuracao/webhook" class="notify-item p-0">
            <feather type="cloud" class="icon-dual icon-xs mr-2"></feather>
            <span>WebHook</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="!isEmpresa169" href="/docs/videos" class="notify-item p-0">
            <feather type="twitch" class="icon-dual icon-xs mr-2"></feather>
            <span>Treinamento</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="!isEmpresa169" href="/docs/suporte" class="notify-item p-0">
            <feather type="help-circle" class="icon-dual icon-xs mr-2"></feather>
            <span>Suporte</span>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item href="/logout" class="notify-item p-0">
            <feather type="log-out" class="icon-dual icon-xs mr-2"></feather>
            <span>Sair</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </div>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}

.ps>.ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
  width: 6px !important;
}

.button-menu-mobile {
  outline: none !important;
}

.btn-webreceita {
  background-color: #008e75;
}

.custom-outline-btn {
  border: 2px solid #fff;
  color: #fff;
  background-color: transparent;
  font-weight: bold;
  transition: all 0.3s ease;
}

.custom-outline-btn:hover {
  background-color: #008e75;
  color: #fff;
  border: 2px solid #fff;
}
</style>
